export const ocplcTableDropDown = `query OcplcTableDropDown {
  ocplcTableDropDown {
    tables {
      subCategory
    }
    parameters {
      subCategory
    }
    localization {
      subCategory
    }
  }
}`;